import { render, staticRenderFns } from "./Ocorrencias.vue?vue&type=template&id=cb0f84cc&"
import script from "./Ocorrencias.vue?vue&type=script&lang=js&"
export * from "./Ocorrencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports